import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { INSTRUMENTS_QUERY_KEY } from "./useInstruments";

export type DeleteInstrumentVariables = {
  instrumentId: string;
};

export function useDeleteInstrument() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteInstrumentVariables>({
    mutationFn: async ({ instrumentId }) => {
      const { error } = await client.DELETE("/api/instruments/{instrument_id}", {
        params: { path: { instrument_id: instrumentId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to delete instrument ${instrumentId}`);
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: INSTRUMENTS_QUERY_KEY });
    },
  });
}
